import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { ApplicationConfig, inject, provideAppInitializer, provideZoneChangeDetection } from '@angular/core';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideRouter, withComponentInputBinding } from '@angular/router';
import { providePrimeNG } from 'primeng/config';
import { DialogService } from 'primeng/dynamicdialog';

import { APP_ROUTES } from '@app/app.routes'; // Your rewritten routes constant
import { AuthService } from '@core/auth/auth.service';
import { urlInterceptor } from '@core/interceptors/url-interceptor';
import { ElinotifyTheme } from '@core/theme/elinotify-theme';

import { environment } from '@env/environment';
import { authInterceptor, LogLevel, provideAuth } from 'angular-auth-oidc-client';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(APP_ROUTES, withComponentInputBinding()),
    provideAnimationsAsync(),
    provideHttpClient(withInterceptors([urlInterceptor, authInterceptor()])),
    provideAuth({
      config: {
        authority: environment.authServer,
        redirectUrl: location.origin,
        clientId: environment.clientId,
        responseType: 'code',
        scope: environment.scope,
        postLogoutRedirectUri: location.origin,
        triggerAuthorizationResultEvent: true,
        renewUserInfoAfterTokenRenew: true,
        silentRenew: true,
        logLevel: LogLevel.Warn,
        useRefreshToken: true,
        secureRoutes: ['/api', environment.apiUrl],
        ignoreNonceAfterRefresh: true,
      },
    }),
    DialogService,
    provideAppInitializer(() => {
      const authService = inject(AuthService);
      return authService.init();
    }),
    providePrimeNG({
      theme: {
        preset: ElinotifyTheme,
        options: {
          darkModeSelector: 'none',
        },
      },
    }),
  ],
};
